// extracted by mini-css-extract-plugin
export default {"wrapper":"Navbar_wrapper__hWQzu","navItemWrapper":"Navbar_navItemWrapper__0x4p5","navItem":"Navbar_navItem__hsOWo"};